import React from "react";
import PageHeader from "../../components/PageHeader";
import SettingCreateComponent from "../../components/Setting/SettingCreate";

class SettingCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        console.log(" ********* setting create *** ");
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Setting Create"
                            Breadcrumb={[
                                { name: "Setting Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <SettingCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SettingCreate;
